import React from 'react';
import { Box } from '@mui/material';
import { Grid, Typography } from '@material-ui/core';

const CustomCardImage = (props) => {
    const {
        title, scorePercentage, icon, alt,
        firstCircleColour, secondCircleColour,
        iconBg, cardBackgroundColor = '#e9e2e21a',
        customStyle = {}
    } = props

    return (
        <Grid sx={{
            display: 'flex',
            alignItems: 'center',
            width: { lg: '25%', md: '25%', sm: '45%', xs: '90%' },
            minHeight: '80px',
            backgroundColor: cardBackgroundColor,
            borderRadius: '16px',
            boxShadow: '1px 1px 5px 0px #0006',
            position: 'relative',
            overflow: 'hidden',
            padding: { lg: '24px', md: '24px', sm: '16px', xs: '24px' },
            margin: customStyle?.margin ?? {
                lg: '0px 15px',
                md: '0px 15px',
                sm: '8px',
                xs: '16px 0px',
            },

        }} xs={12} item>
            <Box sx={{
                content: '""',
                position: 'absolute',
                bottom: '20px',
                right: '-63px',
                width: '105px',
                height: '105px',
                background: firstCircleColour,
                borderRadius: '50%',
            }} />
            <Box sx={{
                display: 'flex',
                flexShrink: 0,
                alignItems: 'center',
                justifyContent: 'center',
                width: { lg: '50px', md: '50px', sm: '40px', xs: '50px' },
                height: { lg: '50px', md: '50px', sm: '40px', xs: '50px' },
                backgroundColor: iconBg,
                borderRadius: '8px',
            }}>
                <img src={icon} alt={alt} style={{ height: '28px' }} />
            </Box>
            <Box sx={{
                marginLeft: { lg: '32px', md: '16px', sm: '12px', xs: '16px' },
                minWidth: 0,
            }}>

                <Typography
                    sx={{
                        fontWeight: "normal",
                        fontSize: { lg: '15px', xl: '17px', sm: '13px', md: '14px' },
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    }} >
                    {title}
                </Typography>
                <Typography
                    sx={{
                        fontSize: { lg: '20px', xl: '25px', sm: '15px', md: '16px' },
                        fontWeight: 600
                    }}>
                    {scorePercentage}
                </Typography>
            </Box>
            <Box sx={{
                content: '""',
                position: 'absolute',
                bottom: '-50px',
                right: '-50px',
                width: '120px',
                height: '105px',
                background: secondCircleColour,
                borderRadius: '50%',
            }} />
        </Grid>
    );
};

export default CustomCardImage;
